<template>
  <v-data-table :headers="headers"
                :items="contacts"
                :loading="loading"
                :items-per-page="100"
                :footer-props="{'items-per-page-options': [10, 50, 100, 500, 1000]}"
                :search="search">

    <template v-slot:item.id="{item: contact}">
      <v-btn :to="{name: 'admin.fax_contact.edit', params: {contactID: contact.id}}"
             small
             icon
             title="Edit contact">
        <v-icon>
          fal fa-pencil
        </v-icon>
      </v-btn>

      <v-btn v-if="contact.messages.length === 0"
             @click.prevent="deleteContact(contact.id)"
             small
             icon
             title="Delete contact">
        <v-icon>
          fal fa-trash
        </v-icon>
      </v-btn>
    </template>

    <template v-slot:item.status="{item: contact}">
      <v-menu offset-y>
        <template v-slot:activator="{on, attrs}">
          <v-btn x-small
                 v-bind="attrs"
                 v-on="on">
            {{ contact.status }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="contact.is_active"
                       @click.prevent="unsubscribe(contact.id)">
            <v-list-item-title>
              Unsubscribe
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-else
                       @click.prevent="resubscribe(contact.id)">
            <v-list-item-title>
              Resubscribe
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <template v-slot:item.created_at="{item: contact}">
      {{ contact.created_at | datetime('MMM D, YYYY') }}
    </template>
    <template v-slot:item.updated_at="{item: contact}">
      {{ contact.updated_at | datetime('MMM D, YYYY') }}
    </template>
    <template v-slot:item.fax_number="{item: contact}">
      {{ contact.fax_number_national }}
    </template>
  </v-data-table>
</template>
<script>
import faxService from '../../../../services/faxService';

export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    contacts: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      required: false,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Company',
          value: 'company_name',
        },
        {
          text: 'Fax Number',
          value: 'fax_number',
          cellClass: 'text-nowrap',
        },
        { // MLD-4007
          text: 'Salutation',
          value: 'salutation',
        },
        {
          text: 'Name',
          value: 'name',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Designation',
          value: 'designation',
        },
        {
          text: 'NPI',
          value: 'npi',
        },
        {
          text: 'City',
          value: 'locality',
        },
        {
          text: 'State',
          value: 'administrative_area',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Created',
          value: 'created_at',
        },
        {
          text: 'Updated',
          value: 'updated_at',
        },
        {
          text: 'Actions',
          value: 'id',
          sortable: false,
        },
      ]
    }
  },
  methods: {
    deleteContact(contactID) {
      faxService.deleteContact(contactID)
        .then(() => {
          setTimeout(() => {
            this.$emit('updated');
          }, 500);
        })
        .catch(() => {
          this.$toast.error('You cannot delete that contact.');
        })
    },
    unsubscribe(contactID) {
      if (confirm(`Are you sure you want to unsubscribe this contact?`)) {
        faxService.unsubscribeContact(contactID)
          .then(() => {
            setTimeout(() => {
              this.$emit('updated');
            }, 500);
          })
          .catch(() => {
            this.$toast.error('You cannot unsubscribe that contact.');
          })
      }
    },
    resubscribe(contactID) {
      if (confirm(`Are you sure you want to resubscribe this contact?`)) {
        faxService.resubscribeContact(contactID)
          .then(() => {
            setTimeout(() => {
              this.$emit('updated');
            }, 500);
          })
          .catch(() => {
            this.$toast.error('You cannot resubscribe that contact.');
          })
      }
    }
  }
}
</script>
